import { Component, Vue, Ref } from "vue-property-decorator";
import { GOOGLE_MAPS_API_KEY } from "@/utils/Constants";
import { ScoutingArea, ScoutingPlace } from "@/models";
import { ScoutingAnalysis } from "@/models/Scouting";
import VMap from "@/components/Scouting/Map.vue";

@Component
export default class ScoutingGroupHelperMixin extends Vue {
  @Ref("scoutingMap") readonly map!: VMap;

  analysis: ScoutingAnalysis | null = null;
  selectedPlaces: ScoutingPlace[] = [];
  selectedAreas: ScoutingArea[] = [];
  googleMapsLoaded = false;

  get scriptUrl() {
    return `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places&language=it`;
  }

  get scoutingAreas() {
    return this.analysis?.scouting.scoutingAreas || [];
  }

  get scoutingPlaces() {
    return this.analysis?.scouting.scoutingPlaces || [];
  }

  get companyId() {
    return this.$route.params.id;
  }

  get analysisId() {
    return this.$route.params.analysisId;
  }

  async loadGoogleMaps() {
    if (!window.google?.maps?.places) {
      const plugin = document.createElement("script");
      plugin.setAttribute("src", this.scriptUrl);
      plugin.async = true;
      document.head.appendChild(plugin);
      await new Promise((resolve) => (plugin.onload = resolve));
    }
    this.googleMapsLoaded = true;
  }

  addScoutingPlaceToMap(place: ScoutingPlace) {
    if (this.googleMapsLoaded) {
      if (place) {
        place.highlighted = true;
        this.map.addMarker(place);
      }
    }
  }

  removeScoutingPlaceFromMap(place: ScoutingPlace) {
    if (this.googleMapsLoaded) {
      if (place) {
        place.highlighted = false;
        this.map.removeMarker(place.id);
      }
    }
  }

  addScoutingAreaToMap(area: ScoutingArea) {
    if (this.googleMapsLoaded) {
      if (area) {
        area.highlighted = true;
        this.map.addArea(area);
      }
    }
  }

  removeScoutingAreaFromMap(area: ScoutingArea) {
    if (this.googleMapsLoaded) {
      if (area) {
        area.highlighted = false;
        this.map.removeArea(area.id);
      }
    }
  }

  onElementAdded(item: any) {
    if (item.groupType === "place") {
      const place = this.scoutingPlaces.find((e) => e.id === item.id)!;
      this.addScoutingPlaceToMap(place);
      this.selectedPlaces.push(place);
      this.map.centerOnPlaces(this.selectedPlaces);
    }

    if (item.groupType === "area") {
      const area = this.scoutingAreas.find((e) => e.id === item.id)!;
      this.addScoutingAreaToMap(area);
      this.selectedAreas.push(area);
      this.map.centerOnSelectedAreas(this.selectedAreas);
    }
  }

  onElementRemoved(item: any) {
    if (item.groupType === "place") {
      const place = this.scoutingPlaces.find((e) => e.id === item.id)!;
      this.removeScoutingPlaceFromMap(place);
      this.selectedPlaces.splice(
        this.selectedPlaces.findIndex((e) => e.id === place.id)!,
        1
      );
      this.map.centerOnPlaces(this.selectedPlaces);
    }

    if (item.groupType === "area") {
      const area = this.scoutingAreas.find((e) => e.id === item.id)!;
      this.removeScoutingAreaFromMap(area);
      this.selectedAreas.splice(
        this.selectedAreas.findIndex((e) => e.id === area.id)!,
        1
      );
      this.map.centerOnSelectedAreas(this.selectedAreas);
    }
  }
}
